export enum AdsPage {
	MAIN_PAGE = "MAIN_PAGE",
	GAME_PAGE = "GAME_PAGE",
	BOARD_GAME_PAGE = "BOARD_GAME_PAGE",
	MOVIE_PAGE = "MOVIE_PAGE",
	SERIES_PAGE = "SERIES_PAGE",
	NEWS_PAGE = "NEWS_PAGE",
	ANOTHER_PAGE = "ANOTHER_PAGE",
}

export const AdsPageLabels: Record<AdsPage, string> = {
	[AdsPage.MAIN_PAGE]: "صفحه اصلی",
	[AdsPage.GAME_PAGE]: "صفحه بازی",
	[AdsPage.BOARD_GAME_PAGE]: "صفحه بازی‌های رومیزی",
	[AdsPage.MOVIE_PAGE]: "صفحه فیلم",
	[AdsPage.SERIES_PAGE]: "صفحه سریال",
	[AdsPage.NEWS_PAGE]: "صفحه اخبار",
	[AdsPage.ANOTHER_PAGE]: "صفحه دیگر",
};
